<template>
  <div
    class="w-full flex flex-col gap-2"
  >
    <div
      class="w-full flex flex-col gap-2 overflow-x-auto z-0 relative"
      style="min-height: 50vh"
    >
      <table
        class="w-full h-full p-4 space-y-5"
        style="background-color: #DEDEDE50;"
      >
        <thead>
          <tr>
            <th
              v-for="header in tableHeaders.filter(h => ['action','calculate_type'].includes(h.key))"
              :key="header.key"
              :rowspan="2"
              class="border border-gray-400 px-2 py-4 align-bottom text-base"
              :style="{ minWidth: header.minWidth || 'auto', width: header.width || 'auto' }"
            >
              {{ header.label }}
            </th>

            <!-- kolom group -->
            <th
              v-for="group in tableGroups"
              :key="group.key"
              :colspan="tableHeaders.filter(h => h.group === group.key).length"
              class="border border-gray-400 px-2 py-2 text-center text-base"
            >
              {{ group.label }}
            </th>

            <th
              v-for="header in tableHeaders.filter(h => ['blending_ratio'].includes(h.key))"
              :key="header.key"
              :rowspan="2"
              class="border border-gray-400 px-2 py-4 align-bottom text-base"
              :style="{ minWidth: header.minWidth || 'auto', width: header.width || 'auto' }"
            >
              {{ header.label }}
            </th>
          </tr>
          <tr>
            <th
              v-for="header in tableHeaders.filter(h => h.group)"
              :key="header.key"
              class="px-2 py-4 align-bottom text-base"
              :style="{ minWidth: header.minWidth || 'auto', width: header.width || 'auto' }"
            >
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <draggable
          tag="tbody"
          v-model="tbsBlendingData"
          ghost-class="ghost"
          :animation="300"
          :force-fallback="true"
          :fallback-on-body="true"
          handle=".drag-handle"
          @end="updateDisplayOrder"
        >
          <tr
            v-for="(row,index) in tbsBlendingData"
            :key="`${index}-${row.barge_name_1}-${row.barge_name_2}`"
            class="w-full select-none"
            :class="'border-b-4'"
            :style="'border-color:#DEDEDE50'"
          >
            <!-- eslint-disable-next-line vue/no-v-for-template-key -->
            <td
              class="px-2 py-2 bg-white border-white rounded-tl-lg rounded-bl-lg"
            >
              <div class="w-full flex justify-around">
                <vs-icon
                  color="primary"
                  class="w-6 rounded-md bg-transparent cursor-pointer drag-handle"
                  :icon="'menu'"
                />
                <button
                  class="bg-primary text-white rounded"
                  @click="onDeleteRow(index)"
                >
                  <img :src="require('@/assets/shipo-icon-delete.svg')">
                </button>
              </div>
            </td>
            <td
              class="px-2 py-2 bg-white border-white"
            >
              <SelectWithSearch
                bottom
                v-model="row.calculate_type"
                :options="calculateTypes"
                :disabled="!!row.loading_plan_id_1"
                placeholder="Select Type"
                @input="val => onChangeCalculateType(row,val)"
              />
            </td>
            <td
              class="px-2 py-2 bg-white border-white"
              style="z-index: 100000"
            >
              <SelectWithSearch
                bottom
                v-model="row.loading_plan_id_1"
                :options="filterLoadingPlansFirst(row,'TUG')"
                placeholder="Select Tug"
                @input="val => onLoadingPlanFirstChange(row,val)"
              />
            </td>
            <td class="px-2 py-2 bg-white border-white">
              <SelectWithSearch
                bottom
                v-model="row.loading_plan_id_1"
                :options="filterLoadingPlansFirst(row,'BARGE')"
                placeholder="Select Barge"
                @input="val => onLoadingPlanFirstChange(row,val)"
              />
            </td>
            <td
              class="px-2 py-2 bg-white border-r-4"
              :style="'border-color:#DEDEDE50'"
            >
              <v-autonumeric
                bottom
                v-model="row.quantity_1"
                @input="newVal => recalculateQtyAndRatio(row, 1, newVal)"
                class="autonumeric-primary"
                :options="{ emptyInputBehavior: 'null'}"
                :placeholder="'Quantity'"
              />
            </td>
            <td class="px-2 py-2 bg-white border-white">
              <SelectWithSearch
                bottom
                v-model="row.loading_plan_id_2"
                :options="filterLoadingPlansSecond(row,'TUG')"
                :disabled="row.calculate_type === 'NON-BLENDING'"
                placeholder="Select Tug"
                @input="val => onLoadingPlanSecondChange(row,val)"
                :is-need-button-link="true"
                :button-link-text="row.show_all_loading_plan_with_same_blending ? 'Show Blending Group Only': 'Show All'"
                @link="onShowAllLoadingPlanWithSameBlending(row)"
                @on-close-options="onCloseOptions(row)"
              />
            </td>
            <td class="px-2 py-2 bg-white border-white">
              <SelectWithSearch
                bottom
                v-model="row.loading_plan_id_2"
                :options="filterLoadingPlansSecond(row,'BARGE')"
                :disabled="row.calculate_type === 'NON-BLENDING'"
                placeholder="Select Barge"
                @input="val => onLoadingPlanSecondChange(row,val)"
                :is-need-button-link="true"
                button-link-text="Show All"
                @link="onShowAllLoadingPlanWithSameBlending(row)"
                @on-close-options="onCloseOptions(row)"
              />
            </td>
            <td
              class="px-2 py-2 bg-white border-r-4"
              :style="'border-color:#DEDEDE50'"
            >
              <v-autonumeric
                v-model="row.quantity_2"
                @input="newVal => recalculateQtyAndRatio(row, 2, newVal)"
                :disabled="row.calculate_type === 'NON-BLENDING'"
                :options="{ emptyInputBehavior: 'null'}"
                class="autonumeric-primary"
                style="width: fit-content;"
                :placeholder="'Quantity'"
              />
            </td>
            <td class="px-2 py-2 bg-white border-white rounded-tr-lg rounded-br-lg text-primary font-semibold w-full">
              <div
                class="flex justify-around gap-2"
                style="width: 90px;"
              >
                <div class="w-full">
                  {{ toPercentageString(row.blending_ratio_1) }}
                </div>
                <div class="w-full">
                  {{ toPercentageString(row.blending_ratio_2) }}
                </div>
              </div>
            </td>
          </tr>
        </draggable>
      </table>
    </div>
    <vs-button
      type="filled"
      color="secondary"
      class="rounded-lg flex flex-row justify-center w-full py-1 focus:outline-none"
      @click="addBlendingRow"
    >
      <div class="w-full flex flex-row items-center gap-3">
        <vs-icon
          icon="add_box"
          size="2rem"
          color="white"
        />
        <div>Add Blending</div>
      </div>
    </vs-button>
  </div>
</template>

<script>
import _ from 'lodash'
import draggable from 'vuedraggable'

import SelectWithSearch from '@/components/selectWithSearch'
export default {
  components: { SelectWithSearch, draggable },
  watch: {
    tbsDataList: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val.length) {
          this.tbsBlendingData = [...val.map(t => ({
            id: t.id,
            display_order: t.display_order,
            calculate_type: t.calculate_type,
            blending_scheme_group: t.details?.[0]?.loading_plan_detail?.blending_scheme_group,
            blending_scheme_ratio: t.details?.[0]?.loading_plan_detail?.blending_scheme_ratio,
            tug_name_1: t.details?.[0]?.loading_plan_detail?.barge_line_up?.tug,
            barge_name_1: t.details?.[0]?.loading_plan_detail?.barge_line_up?.barge,
            quantity_1: t.details?.[0]?.quantity,
            loading_plan_id_1: t.details?.[0]?.loading_plan_detail?.id,
            blending_ratio_1: t.details?.[0]?.quantity / ((t.details?.[0]?.quantity || 0) + (t.details?.[1]?.quantity || 0)),
            tug_name_2: t.calculate_type === 'BLENDING' ? t.details?.[1]?.loading_plan_detail?.barge_line_up?.tug : null,
            barge_name_2: t.calculate_type === 'BLENDING' ? t.details?.[1]?.loading_plan_detail?.barge_line_up?.barge : null,
            quantity_2: t.calculate_type === 'BLENDING' ? t.details?.[1]?.quantity : null,
            loading_plan_id_2: t.calculate_type === 'BLENDING' ? t.details?.[1]?.loading_plan_detail?.id : null,
            blending_ratio_2: t.calculate_type === 'BLENDING' ? t.details?.[1]?.quantity / ((t.details?.[0]?.quantity || 0) + (t.details?.[1]?.quantity || 0)) : null,
            show_all_loading_plan_with_same_blending: false
          }))]
        }
      }
    },
    tbsBlendingData: {
      deep: true,
      handler(val) {
        if(val.length) {
          const payloadBlending = val.map(blending => ({
            tbs_header_id: this.tbsHeaderId,
            blending_type: 'BLENDING',
            calculate_type: blending.calculate_type,
            name: blending.calculate_type === 'BLENDING' ? `BLENDING ${blending.blending_scheme_ratio}` : 'NON-BLENDING',
            total_quantity: blending.quantity_1 + blending.quantity_2,
            display_order: blending.display_order,
            tbs_data_detail: [
              {
                loading_plan_detail_id: blending.loading_plan_id_1,
                is_storage: false,
                storage_id: null,
                quantity: blending.quantity_1
              },
              ...blending.calculate_type === 'BLENDING' ? [{
                loading_plan_detail_id: blending.loading_plan_id_2,
                is_storage: false,
                storage_id: null,
                quantity: blending.quantity_2
              }]: []
            ]
          }))
          this.calculateRemainingTonnage()
          this.validateData()
          this.setPayloadBlending(payloadBlending.filter(p => p.total_quantity > 0))
        } else {
          this.addBlendingRow()
        }
      }
    },
    loadingPlanList: {
      immediate: true,
      deep: true,
      handler(val) {
        this.loadingPlans = [...val.map(v => ({
          ...v,
          assigned_tonnage: 0,
          remaining_tonnage: v.blu_data.actual_tonnage
        }))].filter(lp => lp.remaining_tonnage > 0)

        if(!this.tbsDataList.length && !this.tbsBlendingData.length) {
          this.tbsBlendingData = this.loadingPlans.filter(p => p.blending_scheme_spec === 'NON-BLENDING' && p?.blu_data?.actual_tonnage > 0).map(
            (p,i) => ({
              display_order: i + 1,
              calculate_type: p.blending_scheme_spec,
              blending_scheme_group: p.blending_scheme_group,
              blending_scheme_ratio: p.blending_scheme_ratio,
              tug_name_1: p?.blu_data?.tug,
              barge_name_1: p?.blu_data?.barge,
              quantity_1: p?.blu_data?.actual_tonnage || 0,
              loading_plan_id_1: p?.id,
              blending_ratio_1: 1, // Must be 100% because no other ratio from second tug
              tug_name_2: null,
              barge_name_2: null,
              quantity_2: null,
              loading_plan_id_2: null,
              blending_ratio_2: 0,
              show_all_loading_plan_with_same_blending: false
            })
          )
        }
      }
    },
    errors: {
      handler(val) {
        this.setErrorList(val)
      }
    }
  },
  data() {
    return {
      tableGroups: [
        { label: 'Tug / Barge 1', key: 'loading_plan_1' },
        { label: 'Tug / Barge 2', key: 'loading_plan_2' }
      ],
      tableHeaders: [
        { label: 'Action', key: 'action', minWidth: '5rem', width: '5rem' },
        { label: 'Type', key: 'calculate_type' },
        { label: 'Tug Name', key: 'tug_name_1', group: 'loading_plan_1', width: '3rem' },
        { label: 'Barge Name', key: 'barge_name_1', group: 'loading_plan_1' },
        { label: 'Quantity', key: 'quantity_1', group: 'loading_plan_1' },
        { label: 'Tug Name', key: 'tug_name_2', group: 'loading_plan_2', width: '3rem' },
        { label: 'Barge Name', key: 'barge_name_2', group: 'loading_plan_2' },
        { label: 'Quantity', key: 'quantity_2', group: 'loading_plan_2' },
        { label: 'Blending Ratio', key: 'blending_ratio'}
      ],
      calculateTypes: [{text: 'Blending', value: 'BLENDING'},{text: 'Non Blending', value: 'NON-BLENDING'}],
      tbsBlendingData: [],
      loadingPlans: [],
      errors: []
    }
  },
  methods: {
    getValue(obj, path) {
      return path.split('.').reduce((acc, part) => acc?.[part], obj);
    },
    onLoadingPlanFirstChange(row, value) {
      const loadingPlan = this.loadingPlans.filter(p => p.id === value)[0]
      if(loadingPlan) {
        row.loading_plan_id_1 = value;
        row.blending_scheme_group = loadingPlan.blending_scheme_group;
        row.blending_scheme_ratio = loadingPlan.blending_scheme_ratio;
        row.tug_name_1 = loadingPlan.blu_data.tug;
        row.barge_name_1 = loadingPlan.blu_data.barge;
        if(row.calculate_type === 'NON-BLENDING' || row.blending_scheme_ratio === '50:50') row.quantity_1 = loadingPlan.blu_data.actual_tonnage;
      }
      // if loading plan 2 not in the same group then set to null
      if(this.loadingPlans.find(p => p.id === row.loading_plan_id_2)?.blending_scheme_group !== row.blending_scheme_group) {
        row.tug_name_2 = null;
        row.barge_name_2 = null;
        row.loading_plan_id_2 = null;
        row.quantity_2 = 0;
      }
  
      if(row.blending_scheme_ratio === '50:50' && row.calculate_type === 'BLENDING' && !row.loading_plan_id_2) {
        const loadingPlanIdsDisabled = this.loadingPlans.filter(lp => lp.remaining_tonnage <= 0).map(lp => lp.id)
        const availablePlans = this.loadingPlans
          .filter(plan => plan.blending_scheme_spec === row.calculate_type)
          .filter(l => l.blending_scheme_group === row.blending_scheme_group 
            && l.id !== row.loading_plan_id_1 && !loadingPlanIdsDisabled.includes(l.id))
        if(availablePlans.length === 1) {
          const autoSelectedPlan = availablePlans[0]
          row.loading_plan_id_2 = autoSelectedPlan.id
          row.tug_name_2 = autoSelectedPlan.blu_data.tug
          row.barge_name_2 = autoSelectedPlan.blu_data.barge
          row.quantity_2 = autoSelectedPlan.blu_data.actual_tonnage
          this.recalculateQtyAndRatio(row, 2, row.quantity_2)
        }
      }
    },
    onLoadingPlanSecondChange(row, value) {
      const loadingPlan = this.loadingPlans.filter(p => p.id === value)[0]
      if(loadingPlan) {
        row.loading_plan_id_2 = value;
        row.tug_name_2 = loadingPlan?.blu_data?.tug,
        row.barge_name_2= loadingPlan?.blu_data?.barge
        if(row.blending_scheme_ratio) {
          row.quantity_2 = loadingPlan?.blu_data?.actual_tonnage
          this.recalculateQtyAndRatio(row, 2, row.quantity_2)
        }
      }
    },
    toPercentageString(value) {
      return `${_.round(100* (value || 0),2)} %`
    },
    recalculateQtyAndRatio(row, qtyIndex, newVal) {
      row[`quantity_${qtyIndex}`] = newVal
      row.blending_ratio_1 = row.quantity_1 / ((row.quantity_1 || 0) + (row.quantity_2 || 0))
      row.blending_ratio_2 = row.quantity_2 / ((row.quantity_1 || 0) + (row.quantity_2 || 0))
    },
    updateDisplayOrder() {
      // After drag, update display_order to reflect new order
      this.tbsBlendingData.forEach((item, idx) => {
        item.display_order = idx + 1
      })
    },
    onChangeCalculateType(row, value) {
      row.calculate_type = value
      if(value === 'NON-BLENDING') {
        row.tug_name_2 = null
        row.barge_name_2 = null
        row.quantity_2 = null
        row.loading_plan_id_2 = null
      } else {
        row.quantity_2 = 0
      }
    },
    addBlendingRow() {
      // if already have 1 data minimum then check if there is any data emply
      if(this.tbsBlendingData.length > 0) {
        if(this.isHaveBlendingEmpty()) {
          return this.showWarningNotification(this, 'Please fill in the empty row before creating another row.')
        }
      }
      this.tbsBlendingData.push({
        display_order: this.tbsBlendingData.length + 1,
        calculate_type: 'BLENDING', // Default
        blending_scheme_group: null,
        blending_scheme_ratio: null,
        tug_name_1: null,
        barge_name_1: null,
        quantity_1: 0,
        loading_plan_id_1: null,
        blending_ratio_1: null,
        tug_name_2: null,
        barge_name_2: null,
        quantity_2: 0,
        loading_plan_id_2: null,
        blending_ratio_2: null,
        show_all_loading_plan_with_same_blending: false
      })
    },
    onDeleteRow(index) {
      this.tbsBlendingData.splice(index, 1)
    },
    filterLoadingPlansFirst(row, type) {
      const loadingPlanIdsDisabled = this.loadingPlans.filter(lp => lp.remaining_tonnage <= 0).map(lp => lp.id).filter(id => id !== row.loading_plan_id_1)
      const planFiltered = this.loadingPlans
        .filter(plan => plan.blending_scheme_spec === row.calculate_type)
        .filter(plan => !loadingPlanIdsDisabled.includes(plan.id))
      const planDropdowns = planFiltered.map(p => ({ text: type === 'TUG' ? p.blu_data.tug : p.blu_data.barge, value: p.id }))

      // Handle if value not exist on dropdowns
      if(!planDropdowns.find(p => p.value === row.loading_plan_id_1)) planDropdowns.push({ text: type === 'TUG' ? row.tug_name_1: row.barge_name_1, value: row.loading_plan_id_1 })
      return planDropdowns
    },
    filterLoadingPlansSecond(row, type) {
      const loadingPlanIdsDisabled = this.loadingPlans.filter(lp => lp.remaining_tonnage <= 0).map(lp => lp.id).filter(id => id !== row.loading_plan_id_2)
      const planFiltered = 
      !row.show_all_loading_plan_with_same_blending ? this.loadingPlans
        .filter(plan => plan.blending_scheme_spec === row.calculate_type)
        .filter(l => l.blending_scheme_group === row.blending_scheme_group 
        && l.id !== row.loading_plan_id_1 && !loadingPlanIdsDisabled.includes(l.id))
        : this.loadingPlans
          .filter(plan => plan.blending_scheme_spec === row.calculate_type)
          .filter(l => l.blending_scheme_ratio === row.blending_scheme_ratio 
        && l.id !== row.loading_plan_id_1 && !loadingPlanIdsDisabled.includes(l.id))
      const planDropdowns = planFiltered.map(p => ({ text: type === 'TUG' ? p.blu_data.tug : p.blu_data.barge, value: p.id }))
      
      // Handle if value not exist on dropdowns
      if(!planDropdowns.find(p => p.value === row.loading_plan_id_2)) planDropdowns.push({ text: type === 'TUG' ? row.tug_name_2 : row.barge_name_2, value: row.loading_plan_id_2 })
      return planDropdowns
    },
    calculateRemainingTonnage() {
      const loadingPlanIdQty = _.flatMap(this.tbsBlendingData, t => [
        { id: t.loading_plan_id_1, qty: t.quantity_1 },
        { id: t.loading_plan_id_2, qty: t.quantity_2 }
      ]).filter(x => x.id != null)

      const loadingPlanIdTotalQty = _(loadingPlanIdQty)
        .groupBy("id")
        .map((items, id) => ({
          loading_plan_id: id,
          total_quantity: _.sumBy(items, "qty")
        }))
        .value()
      
      this.loadingPlans = this.loadingPlans.map(lp => ({
        ...lp,
        assigned_tonnage: loadingPlanIdTotalQty.find(l => l.loading_plan_id == lp.id)?.total_quantity || 0,
        remaining_tonnage: lp.blu_data.actual_tonnage - (loadingPlanIdTotalQty.find(l => l.loading_plan_id == lp.id)?.total_quantity || 0)
      }))  
    },
    isHaveBlendingEmpty() {
      return this.tbsBlendingData.some(t => !t.quantity_1 || !t.tug_name_1)
    },
    onShowAllLoadingPlanWithSameBlending(row) {
      // toggle
      row.show_all_loading_plan_with_same_blending = !row.show_all_loading_plan_with_same_blending
      if(row.show_all_loading_plan_with_same_blending) {
        const tbsIndex = this.tbsBlendingData.findIndex(t => t.display_order === row.display_order)
        this.$set(this.tbsBlendingData[tbsIndex], "show_all_loading_plan_with_same_blending", true);
      } else {
        const tbsIndex = this.tbsBlendingData.findIndex(t => t.display_order === row.display_order)
        this.$set(this.tbsBlendingData[tbsIndex], "show_all_loading_plan_with_same_blending", false);
      }
    },
    onCloseOptions(row) {
      row.show_all_loading_plan_with_same_blending = false
    },
    validateData() {
      const errors = []
      const selectedLoadingPlanIds = _.flatMap(this.tbsBlendingData, t => [t.loading_plan_id_1, t.loading_plan_id_2])
      const loadingPlansAssigned = this.loadingPlans.filter(lp => selectedLoadingPlanIds.includes(lp.id))
      const loadingPlansAssignedGroupIds = loadingPlansAssigned.filter(lp => lp.blending_scheme_group !== null).map(lp => lp.blending_scheme_group)
      const loadingPlanInTheSameGroups = this.loadingPlans.filter(lp => loadingPlansAssignedGroupIds.includes(lp.blending_scheme_group) && !selectedLoadingPlanIds.includes(lp.id))

      loadingPlansAssigned.forEach(lp => {
        if(lp.remaining_tonnage > 0) errors.push(`Fleet ${lp.blu_data.tug}/${lp.blu_data.barge} still has <b>${lp.remaining_tonnage} TON</b> remaining`)
        if(lp.remaining_tonnage < 0) errors.push(`Fleet ${lp.blu_data.tug}/${lp.blu_data.barge} is is overloaded by <b>${Math.abs(lp.remaining_tonnage)} TON</b>`)
      })
      loadingPlanInTheSameGroups.forEach(lp => {
        if((lp.assigned_tonnage > 0) === false) {
          const lpAssignedWithThisGroup = loadingPlansAssigned.find(lpx => lpx.blending_scheme_group === lp.blending_scheme_group)
          errors.push(`Fleet ${lp.blu_data.tug}/${lp.blu_data.barge} of Group ratio <b>${lp.blending_scheme_ratio}</b> with <b>${lpAssignedWithThisGroup.blu_data.tug}/${lpAssignedWithThisGroup.blu_data.barge}</b>  not assigned yet`)}
      })

      this.tbsBlendingData.filter(t => t.calculate_type === 'BLENDING').forEach(blending => {
        if(blending.blending_scheme_ratio) {
          const tolerance = 0.5 // max deviation 50%
          const [expected1, expected2] = blending.blending_scheme_ratio
            .split(":")
            .map(Number);

          const total = expected1 + expected2;
          const schemeRatios = [expected1 / total, expected2 / total];
          const actualRatios = [blending.blending_ratio_1, blending.blending_ratio_2];
          const checkMatch = (scheme, actual) =>
            scheme.every(
              (s, i) => Math.abs(s - actual[i]) <= tolerance
            );
          const valid =
          checkMatch(schemeRatios, actualRatios) ||
          checkMatch(schemeRatios, actualRatios.slice().reverse());
          if(!valid) errors.push(`Blending ratio for <b>row ${blending.display_order}</b> does not match Loading Plan <b>(${blending.blending_scheme_ratio})</b>.`)
        }
      })
      
      this.errors = errors
    }
  },
  props: {
    tbsHeaderId: {
      type: Number,
      default: () => null
    },
    tbsDataList: {
      type: Array,
      default: () => []
    },
    loadingPlanList: {
      type: Array,
      default: () => []
    },
    setErrorList: {
      type: Function,
      default: () => {}
    },
    setPayloadBlending: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style scoped>
.autonumeric-primary {
  min-width: 180px;
}
</style>